import "@sphtech/dmg-design-system/dist/theme-hwz.css";
import "@sphtech/dmg-design-system/assets/hwz/fonts.css";

import Newsticker from "@components/Modules/Newsticker/Newsticker";
import { configSite } from "@pub/config";
import { BaseLayout, CustomClassContext } from "@sphtech/dmg-design-system";
import { useLocation } from "react-router";

import { configHeader } from "./config/configHeader";
import customStyle from "./custom.module.css";
import logoSvgSource from "./logo.svg?raw";
import logoSvgBlack from "./logo-black.svg?raw";
import logoSvgInverted from "./logo-inverted.svg?raw";
import { RoutePaths } from "./routePaths";

type HWZBaseLayoutProps = {
  ArticleTitle?: string;
  children: React.ReactNode;
  ads?: boolean;
  leaderboard?: boolean;
  skipMobileBanner?: boolean;
};

/**
 * Reusable Base layout specific to HWZ.
 */
const HWZBaseLayout = ({
  ArticleTitle,
  children,
  ads = true,
  leaderboard = true,
  skipMobileBanner,
}: HWZBaseLayoutProps) => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();

  return (
    <CustomClassContext.Provider
      value={{
        magazineListing: {
          carouselContent: customStyle["homeMagListingCarouselContent"],
        },
        latestArticle: {
          container: customStyle["latestArticleTeaser"],
        },
        navLinks: {
          itemLink: customStyle["navLink"],
        },
        navbar: {
          dropDown: customStyle["navbarDropdown"],
        },
        socialIcons: {
          footerContainer: customStyle["footerSocialIconContainer"],
          megaMenuContainer: customStyle["megaMenuSocialIconsContainer"],
        },
        relatedItem: {
          verticalLine: customStyle.relatedItemVerticalLine,
        },
        subAnchor: {
          item: customStyle["subAnchorItem"],
        },
        categoryLayout: {
          mainContent: {
            item: customStyle["mainContentItem"],
          },
          exploreMoreContainer: customStyle["exploreMoreContainer"],
        },
        megaMenu: {
          details: customStyle["megaMenuDetails"],
          summary: {
            container: customStyle["megaMenuSummaryContainer"],
            buttonItem: customStyle["megaMenuSummaryButton"],
          },
        },
        homeLatestArticle: {
          container: customStyle["homeLatestArticleContainer"],
          item: customStyle["homeLatestArticleItemContainer"],
        },
        homeContentBlockD: {
          container: customStyle["homeContentBlockDContainer"],
          item: customStyle["homeContentBlockDItem"],
          altStyleContainer: customStyle["homeContentBlockDAltStyleContainer"],
          itemContainerAltStyle:
            customStyle["homeContentBlockDItemContainerAltStyle"],
        },
        homeGrid: {
          mainSectionContainer: customStyle["homeGridMainSectionContainer"],
          container: customStyle["homeGridContainer"],
        },
        anchorBlock: {
          container: customStyle["anchorBlockContainer"],
        },
        contentBlock: {
          cta: customStyle["gridMainCta"],
        },
        homeContentBlockF: {
          sectionHeading: customStyle["homeContentBlockFContainer"],
          itemsContainer: customStyle["itemsContainer"],
        },
        homeContentBlockJ: {
          mainSectionContainer: customStyle["homeContentBlockJContainer"],
          itemsContainer: customStyle["itemsContainer"],
        },
        tagLayout: {
          headingContainer: customStyle["tag"],
        },
      }}
    >
      <BaseLayout
        ArticleTitle={ArticleTitle}
        ads={ads}
        leaderboard={leaderboard}
        NewsTicker={<Newsticker />}
        RoutePaths={RoutePaths}
        svgSource={logoSvgSource}
        siteName={configSite.name}
        mciText={
          <span suppressHydrationWarning>
            Copyright © {currentYear} SPH Media Limited. Co. Regn. No.
            202120748H. All rights reserved
          </span>
        }
        socialIconProps={configHeader.socialMedia}
        megaMenuProps={{
          NewsLetterProps: configHeader.megaMenu.newsletter,
          CloseButtonProps: configHeader.megaMenu.closeButton,
          logoSvg: logoSvgBlack,
          menuType: "accordion",
        }}
        currentLocation={location}
        skipMobileBanner={skipMobileBanner}
        footerWithDivider={false}
        navbarDropdownOptions={{
          displayImage: false,
        }}
        sphLogoInverted={true}
        footerSvgSource={logoSvgInverted}
      >
        {children}
      </BaseLayout>
    </CustomClassContext.Provider>
  );
};

export default HWZBaseLayout;
